import { useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as queryString from 'query-string';
import appConfig from '../../../app-config';
import moment from 'moment';
import {
  updateOrderType,
  updateInterOrderType,
  updateInterDropOffDetails,
  // updateSelectedLocation,
  updateInterSelectedDateTime,
  updateOrderSettingModalIsVisible,
  updateInterPickUpDetails,
  updateSelectedLocation,
} from '../OrderSetting/orderSettingActions';
import {
  setAuthenticationModalIsVisible,
  updateLoginOrSignUpScreen,
  changeActionType,
} from '../Auth/authActions';
import { saveDeepLinkDropOffSelection } from '../DropOff/dropOffLocationActions';
import { DROPOFF, PICKUP, DELIVERY } from '../OrderSetting/orderSettingTypes';

const deepLinksClients = [
  'one_king_west',
  'madradish',
  'onekingwest_amenitites',
  'good_earth',
  'iQ',
];
const deepLinkSelectedDateTime = {
  radioValue: {
    name: 'As soon as possible',
    value: 'asap',
  },
  dateTime: {
    date: {
      name: moment().format('ddd MMM DD'),
      value: moment().toString(),
    },
    time: {
      name: '',
      value: '',
    },
  },
};

export default function useLinkParameters(location) {
  const dispatch = useDispatch();
  const availableLocations = useSelector(
    (state) => state.locationsReducer?.locations
  );
  const checkDeepLink = useCallback(() => {
    let isDeepLink = false;
    const params = queryString.parse(location?.search);
    if (params?.signup || params?.login) {
      if (params?.signup === 'true') {
        dispatch(changeActionType('registration'));
        dispatch(updateLoginOrSignUpScreen('registration'));
      } else if (params?.login === 'true') {
        dispatch(changeActionType('login'));
      }
      dispatch(setAuthenticationModalIsVisible(true));
      return;
    }
    if (Object.keys(params).length > 0) {
      localStorage.setItem('business_id', params.storeId);
      const deepLinkLocation = availableLocations.find(
        (location) => location.id === parseInt(params.storeId)
      );

      const deepLinkOrderType = params?.orderType ?? params?.type;
      if (deepLinkOrderType === DROPOFF) {
        const deepLinkDropOffSelection = {
          buildingId: parseInt(params.buildingId),
          floorId: parseInt(params.floorId),
          roomId: parseInt(params.roomId),
        };
        dispatch(updateOrderSettingModalIsVisible(false));
        dispatch(updateInterOrderType(DROPOFF));
        dispatch(updateOrderType(DROPOFF));
        dispatch(
          saveDeepLinkDropOffSelection(
            deepLinkDropOffSelection,
            parseInt(params.storeId)
          )
        );
        dispatch(
          updateInterDropOffDetails(
            deepLinkLocation,
            new Date().toString(),
            true
          )
        );
        dispatch(updateInterSelectedDateTime(deepLinkSelectedDateTime, true));
      } else if (deepLinkOrderType === DELIVERY) {
        dispatch(updateInterOrderType(DELIVERY));
        dispatch(updateOrderSettingModalIsVisible(true));
      } else if (deepLinkOrderType === PICKUP) {
        dispatch(updateInterOrderType(PICKUP));
        dispatch(updateOrderSettingModalIsVisible(true));
        dispatch(updateSelectedLocation(deepLinkLocation));
        dispatch(
          updateInterPickUpDetails(deepLinkLocation, new Date().toString())
        );
      } else {
        dispatch(updateInterOrderType(PICKUP));
        dispatch(updateOrderSettingModalIsVisible(true));
        dispatch(updateSelectedLocation(deepLinkLocation));
        dispatch(
          updateInterPickUpDetails(deepLinkLocation, new Date().toString())
        );
      }
    } else {
      dispatch(updateOrderSettingModalIsVisible(true));
    }
    return isDeepLink;
  }, [availableLocations?.length]);
  useEffect(() => {
    checkDeepLink();
  }, [checkDeepLink]);
}
